"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M702.7 241.9v138.7c.1 1.1.1 2.1 0 3.2v172c.1 11.9-4.7 23.4-13.2 31.9-8.6 8.4-20.1 13.1-32.2 13.1H44.8C20.2 600.8.3 581 0 556.4V147.3c.3-24.7 20.4-44.5 45.1-44.4h612.2c11.9-.1 23.4 4.6 31.9 12.9s13.4 19.6 13.4 31.5v91.4c.2 1.1.2 2.2.1 3.2zM29.3 256.7v109.7h644.2V256.7H29.3zm15.8-124.4c-4.2-.1-8.2 1.5-11.2 4.4s-4.7 6.8-4.7 11v80.1h643.7v-80.1c0-8.5-7-15.4-15.5-15.4H45.1zm612.3 439.2c4.2.2 8.3-1.4 11.4-4.3 3-2.9 4.7-6.9 4.7-11.1V395.4H29.3v160.7c0 4.1 1.7 8.1 4.7 11s7 4.5 11.2 4.4h612.2z"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M702.8 245.6v134.5c0 1.1-.5 1.9-.6 3v165.7c0 28.7-23.8 52.1-53 52.1H53.4C24.1 600.9.3 577.5.3 548.8v-167c-.1-.6-.4-1.1-.4-1.7V245.6c0-.6.3-1.1.4-1.7v-88.8c0-28.8 23.8-52.1 53.1-52.1h595.8c29.2 0 53 23.3 53 52.1v87.5c.1 1 .6 1.9.6 3zm-53.6 311.2c4.5 0 8.2-3.6 8.3-8.1V402.1H45.1v146.7c0 4.5 3.8 8.2 8.3 8.1 0-.1 595.8-.1 595.8-.1zM53.4 147c-4.5-.1-8.3 3.6-8.3 8.1v68.5h612.3v-68.5c0-4.5-3.7-8.1-8.3-8.1H53.4zm-8.3 211.1h612.3v-90.5H45.1v90.5z"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M649.2 556.8H53.4c-4.6 0-8.3-3.6-8.3-8.1V402.1h612.4v146.6c-.1 4.5-3.8 8.1-8.3 8.1zM53.4 147h595.8c4.6 0 8.3 3.6 8.3 8.1v68.5H45.1v-68.5c0-4.5 3.7-8.1 8.3-8.1zm649.4 98.6c0-1.1-.5-2-.6-3v-87.5c0-28.8-23.8-52.1-53-52.1H53.4C24.1 103 .3 126.3.3 155.1v88.8c-.1.6-.4 1.1-.4 1.7v134.5c0 .6.3 1.1.4 1.7v166.9c0 28.7 23.8 52.1 53.1 52.1h595.8c29.2 0 53-23.4 53-52.1V383c.1-1 .6-1.9.6-3V245.6z"
  })
});

var TarjetaCredito = function TarjetaCredito(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "TarjetaCredito-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '-5 0 710 710';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = TarjetaCredito;
exports["default"] = _default;

//# sourceMappingURL=index.js.map